export const WORKBENCH_REQUIREMENT_TEMPLATES_CTRL_METHOD = {
  GET_REQUIREMENT_TEMPLATES: 1,
  SAVE_TEMPLATE: 2,
  DELETE_TEMPLATE: 3,
};
